import React, { useEffect, useState } from "react";
import { collection, query, orderBy, getDocs, where } from "firebase/firestore";
import { Navigate, useParams, useNavigate, useLocation } from "react-router-dom";
import { db } from "../../../config/firebaseConfig";

// フィールド名 → 日本語ラベルのマッピング
const fieldLabels = {
    status: "ステータス",
    masterID: "マスターID",
    uttID: "UTT番号",
    projectID: "プロジェクトID",
    deleted: "削除フラグ",
    deletedAt: "削除日時",
    deletedBy: "削除者",
    updatedAt: "更新日時",
    createdAt: "作成日時",
    remark1:"備考",
    // 電気
    capacityKVA: "電気容量[KVA]",
    capacityA: "電流値[A]",
    electricType: "電気種類",
    electricName: "電気種名",
    // ネットワーク
    networkType: "ネットワーク種",
    networkName: "ネットワーク名",
    MacAddress:"MACアドレス", 
    IPAddress:"IPアドレス", 
    // 給排気
    connectionSize:"接続口サイズ", 
    airType:"給排気種", 
    airName:"給排気名", 

    // 給排水
    capacity:"容量", 
    waterType:"給排水種", 
    waterName:"給排水名", 

};

const Tab06 = () => {
const [logs, setLogs] = useState([]);
const [loading, setLoading] = useState(true);
const { masterID } = useParams();

    useEffect(() => {
        const fetchLogs = async () => {
        try {
            const q = query(
            collection(db, "changeLogs"),
            where("masterID", "==", masterID),
            orderBy("timestamp", "desc") // 🔹 最新順
            );
            const querySnapshot = await getDocs(q);
            const data = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
            }));
            setLogs(data);
        } catch (error) {
            console.error("changeLogsの取得に失敗しました:", error);
        } finally {
            setLoading(false);
        }
        };

        fetchLogs();
    }, [masterID]);

    if (loading) return <p>読み込み中...</p>;

    return (
        <div className="p-4">
        <h2 className="text-xl font-bold mb-4">変更履歴</h2>

        {logs.length === 0 ? (
            <p className="text-gray-500">変更履歴はありません。</p>
        ) : (
        <table className="table-auto border-collapse border border-gray-300 w-full text-sm">
            <thead className="bg-gray-100">
            <tr>
                <th className="border border-gray-300 px-2 py-1">変更日時</th>
                <th className="border border-gray-300 px-2 py-1">変更者</th>
                <th className="border border-gray-300 px-2 py-1">ユーティリティ種</th>
                <th className="border border-gray-300 px-2 py-1">ユーティリティID</th>
                <th className="border border-gray-300 px-2 py-1">変更箇所</th>
                <th className="border border-gray-300 px-2 py-1">変更内容</th>
            </tr>
            </thead>
            <tbody>
            {logs.map((log) => (
                <tr key={log.id} className="hover:bg-gray-50">
                <td className="border border-gray-300 px-2 py-1">
                    {log.timestamp?.toDate().toLocaleString("ja-JP") ?? "-"}
                </td>
                <td className="border border-gray-300 px-2 py-1">{log.userName}</td>
                <td className="border border-gray-300 px-2 py-1">{log.utilityType}</td>
                <td className="border border-gray-300 px-2 py-1">{log.uttID}</td>
                <td className="border border-gray-300 px-2 py-1">{fieldLabels[log.field] || log.field}</td>
                <td className="border border-gray-300 px-2 py-1">
                    <span className="text-gray-500 line-through">{String(log.oldValue)}</span>{" "}
                    → <span className="text-blue-600">{String(log.newValue)}</span>
                </td>
                </tr>
            ))}
            </tbody>
        </table>
        )}
        </div>
    );
    };

export default Tab06;
